(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxOffice', TaxOffice);

    TaxOffice.$inject = ['$resource'];

    function TaxOffice ($resource) {
        var resourceUrl =  'api/tax-offices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
